import { useEffect, useState, useRef, useCallback } from "react";
import { ModalLayout } from "../components/ModalLayout";
import { ModalPortal } from "../components/ModalPortal";
import { useDispatch } from "react-redux";
import { SecurityService } from "../../SharedModule/services/security";
import { setUserRoles } from "../redux/reducers/auth.reducer";
import eventHandler from "../utils/eventHandler";
import { ROUTE_LOG_OUT } from "../utils/constants";
import { BroadcastChannel } from "broadcast-channel";
import { useReacquireToken } from "../hooks/useReacquireToken";

const eventTypes = [
  "keypress",
  "mousemove",
  "mousedown",
  "scroll",
  "touchmove",
  "pointermove",
];
export const addEventListeners = (listener: any) => {
  eventTypes.forEach((type) => {
    window.addEventListener(type, listener, false);
  });
};
export const removeEventListeners = (listener: any) => {
  if (listener) {
    eventTypes.forEach((type) => {
      window.removeEventListener(type, listener, false);
    });
  }
};

export const TimeoutLogic = () => {
  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);

  // Modal config
  const modalRef = useRef<undefined>(undefined);
  const showModal = () => {
    if (modalRef.current) {
      (modalRef.current as any).show(true);
    }
  };
  const closeModal = () => {
    if (modalRef.current as any) {
      (modalRef.current as any).show(false);
    }
  };

  const channel = new BroadcastChannel("session_channel");

  useEffect(() => {
    channel.onmessage = (event) => {
      if (
        event === "logoutWithChannel" &&
        !isModalOpen &&
        globalThis.location.pathname !== ROUTE_LOG_OUT
      ) {
        // Another tab logged out
        showModal();
        setIsModalOpen(true);
        eventHandler.dispatch("logout", {});
        clearTimeout(timer);
      }
    };

    const createTimeout = () =>
      setTimeout(() => {
        if (!isModalOpen && globalThis.location.pathname !== ROUTE_LOG_OUT) {
          showModal();
          setIsModalOpen(true);
          eventHandler.dispatch("logout", {});
          channel.postMessage("logoutWithChannel");
          clearTimeout(timer);
        }
        // set time in miliseconds to force logout and show modal => 1800000
      }, 1800000);

    const listener = () => {
      if (!isModalOpen && globalThis.location.pathname !== ROUTE_LOG_OUT) {
        clearTimeout(timer);
        timer = createTimeout();
      }
    };
    // init
    let timer = createTimeout();
    addEventListeners(listener);
    // Cleanup
    return () => {
      removeEventListeners(listener);
      clearTimeout(timer);
    };
  }, [isModalOpen]);

  const getRoles = useCallback(async () => {
    const userRoles = await SecurityService.getUserRole();
    Array.isArray(userRoles) && dispatch(setUserRoles(userRoles));
  }, [dispatch]);

  const acquireTokenAndLogin = useReacquireToken(getRoles, () =>
    eventHandler.dispatch("login", {})
  );

  const loginAgain = () => {
    closeModal();
    acquireTokenAndLogin();
    setIsModalOpen(false);
  };

  return (
    <ModalPortal ref={modalRef} zIndex={170}>
      <ModalLayout
        title="Your session has timed out"
        text="Click below to Log in again and go back to the page you were on. If we can't bring you back, you will be taken to the Home page."
        btnLabel="Log in again"
        btnAction={loginAgain}
        actionPlaceholder="notCloseOnClickOutside"
      />
    </ModalPortal>
  );
};
